import type { TaskStatus } from '../services/api/types.gen';

export const EDITABLE_STATUSES = new Set<TaskStatus>([
  'not_started',
  'saved',
  'submitted',
  'reopened',
]);

export const SIGNABLE_STATUSES = new Set<TaskStatus>([
  'not_started',
  'saved',
  'submitted',
  'pending_clinician_signature',
  'reopened',
]);

/**
 * Statuses that mean a task is finished. Used by the CMS-485 OASIS picker to
 * decide whether a source visit's data is safe to load — anything earlier
 * should be visually discouraged.
 */
export const COMPLETED_STATUSES = new Set<TaskStatus>([
  'completed',
  'exported',
]);
